import type { CSSProperties } from 'react';

/** The rounded box around the header's date navigator and view toggle. */
export const PILL_BOX: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  background: 'var(--nb-surface)',
  border: '1px solid var(--nb-border)',
  borderRadius: 999,
  padding: 2,
};
